import * as Types from "../actionTypes/timeTableTypes";

export const setTimeTable = (payload) => ({
  type: Types.SET_TIME_TABLE,
  payload,
});
